
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_45778","data-name":"Group 45778","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_14861","data-name":"Rectangle 14861","width":"20","height":"20","fill":"none"}})])]),_c('rect',{attrs:{"id":"Rectangle_14860","data-name":"Rectangle 14860","width":"20","height":"20","fill":"none"}}),_c('g',{attrs:{"id":"Group_44541","data-name":"Group 44541"}},[_c('g',{attrs:{"id":"Group_44540","data-name":"Group 44540","clip-path":"url(#clip-path)","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-width":"1.5"}},[_c('line',{attrs:{"id":"Line_1399","data-name":"Line 1399","y2":"18.423","transform":"translate(2.971 .788)"}}),_c('path',{attrs:{"id":"Path_30414","data-name":"Path 30414","d":"M2.975 1.9h15.676l-4.307 4.783 4.307 4.786H2.975","stroke-linejoin":"round"}})])])])
          )
        }
      }
    